import { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import classes from './UserCourseCard.module.css';

const dateFormat = date => {
  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];
  let newDate = '';
  if (date > 0) {
    let a = new Date(date);
    let year = a.getFullYear();
    let month = months[a.getMonth()];
    let nDate = a.getDate();
    newDate = `${nDate} ${month} ${year}`;
  } else {
    newDate = 'Sin límite';
  }
  return newDate;
};

const UserCourseCard = ({ course }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const openMenuHandler = event => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const closeMenuHandler = () => {
    setAnchorEl(false);
  };

  let progressText = 0;
  if (course.progress <= 20) {
    progressText = `${course.progress + 7}%`;
  } else if (course.progress <= 50) {
    progressText = `${course.progress - 15}%`;
  } else if (course.progress < 99) {
    progressText = `${course.progress - 30}%`;
  } else {
    progressText = `${course.progress - 40}%`;
  }

  return (
    <>
      <IconButton
        onClick={openMenuHandler}
        className={classes.moreBtn}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        classes={{ paper: classes.menuContainer }}
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenuHandler}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem
          className={classes.menuItem}
          component={Link}
          to={`/course/${course.academyShortName}/${course.idCourse}`}
        >
          Ir al curso
        </MenuItem>
        <MenuItem
          onClick={closeMenuHandler}
          className={classes.menuItem}
          component="a"
          href={`${process.env.REACT_APP_API_PATH_MAYAHII_URL}/${course.academyShortName}`}
          target="_blank"
        >
          Ir a la academia
        </MenuItem>
      </Menu>
      <Button
        component={Link}
        to={`/course/${course.academyShortName}/${course.idCourse}`}
        className={classes.courseCard}
      >
        {course.newCourse === 1 && (
          <figure className={classes.newCourseMark}>
            <img
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/newCourseMark.png"
              className={classes.img}
            />
          </figure>
        )}
        <figure className={classes.courseImg}>
          <img
            src={course.courseImage}
            alt={course.nombre}
            className={classes.img}
          />
        </figure>
        <div className={classes.complementaryInfo}>
          <p className={classes.academyName}>{course.academyName}</p>
          <p className={classes.courseName}>{course.nombre}</p>
        </div>
        <p className={classes.limitText}>
          Limite de acceso{' '}
          <span className={classes.limitDate}>
            {dateFormat(course.expirationDate)}
          </span>
        </p>
        <span
          style={{ marginLeft: progressText }}
          className={classes.progressText}
        >
          Avance: {course.progress}%
        </span>
        <LinearProgress
          classes={{
            barColorPrimary: classes.linearBarColorPrimary
          }}
          className={classes.progressBar}
          variant="determinate"
          value={course.progress}
        />
      </Button>
    </>
  );
};

UserCourseCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  course: PropTypes.object
};

export default UserCourseCard;
